/*
General purpose logging methods
 */

/**
 * For logging messages to console only in local development mode, which will be
 * removed from source code completely when building for production.
 *
 * This should be used for warning type messages that only make sense to the
 * developer, and not for testing issues in build process.
 *
 * @param {string} msg - Message to be printed only in local development
 */
function devOnlyLog (msg) {
  if (process.env.NODE_ENV === 'development') {
    console.log(msg)
  }
}

export {
  devOnlyLog
}



// WEBPACK FOOTER //
// ./src/utils/log.js